var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "35px",
    viewBox: "0 0 150 35",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L25.0647 0L25.0647 23.3095L0 23.3095L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L21.5047 0L21.5047 15.8824L0 15.8824L0 0Z",
    id: "path_2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.1382 27.7948L39.9124 5.18763L57.9914 5.18763L56.6924 11.2957L47.109 11.2957L46.6876 13.3319L54.9372 13.3319L53.6034 19.6505L45.3538 19.6505L44.8972 21.6866L54.481 21.6866L53.2174 27.7948L35.1382 27.7948Z",
    id: "Fill-1",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9401 27.7948L64.4156 11.2957L58.6583 11.2957L59.9572 5.18763L79.9668 5.18763L78.6677 11.2957L72.9106 11.2957L69.4354 27.7948L60.9401 27.7948Z",
    id: "Fill-2",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1763 27.7948L82.9505 5.18763L101.029 5.18763L99.7305 11.2957L90.1468 11.2957L89.7257 13.3319L97.9753 13.3319L96.6411 19.6505L88.3916 19.6505L87.9354 21.6866L97.5188 21.6866L96.2552 27.7948L78.1763 27.7948Z",
    id: "Fill-3",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "matrix(1 0 0 1 0 -5.9211893E-15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.578 15.403L112.649 15.403C114.029 15.403 114.837 14.8183 115.071 13.6478C115.094 13.5308 115.112 13.4255 115.124 13.3318C115.135 13.2385 115.142 13.1447 115.142 13.051C115.142 12.232 114.603 11.8222 113.527 11.8222L111.315 11.8222L110.578 15.403ZM99.4496 27.7948L104.224 5.18758L116.932 5.18758C119.131 5.18758 120.846 5.79636 122.074 7.01302C123.303 8.23004 123.918 9.78628 123.918 11.6817C123.918 12.3136 123.847 12.9692 123.707 13.6478C123.402 15.1693 122.777 16.4972 121.829 17.632C120.881 18.7675 119.693 19.7207 118.265 20.4932C118.64 20.7975 118.874 21.1836 118.968 21.6515L120.337 27.7948L111.49 27.7948L110.332 22.7748C110.238 22.2833 109.957 22.0376 109.489 22.0376L109.139 22.0376L107.945 27.7948L99.4496 27.7948Z",
    id: "Fill-4",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(124.93534 4.836437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L25.0647 0L25.0647 23.3095L0 23.3095L0 0Z",
    id: "Clip-7",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5847 16.113C12.8246 16.113 13.7787 15.7795 14.4456 15.1125C15.1125 14.4456 15.6217 13.293 15.9728 11.6547C16.0659 11.2106 16.142 10.8067 16.2008 10.4436C16.259 10.0811 16.2885 9.74763 16.2885 9.44314C16.2885 8.62428 16.0777 8.04505 15.6567 7.70546C15.2356 7.36643 14.5098 7.19645 13.4804 7.19645C12.2393 7.19645 11.2863 7.52994 10.619 8.19693C9.95216 8.86392 9.44296 10.0168 9.09228 11.6547C8.99842 12.0995 8.92803 12.5033 8.88147 12.8658C8.83417 13.2291 8.81107 13.5624 8.81107 13.8663C8.81107 14.6621 9.02189 15.2354 9.44296 15.5865C9.8644 15.9375 10.5779 16.113 11.5847 16.113M10.0399 23.3095C8.02695 23.3095 6.26636 23.0401 4.75686 22.5021C3.24736 21.964 2.07672 21.104 1.2464 19.9219C0.415343 18.7405 0 17.1784 0 15.2354C0 14.1823 0.140418 12.9887 0.42144 11.6547C1.02949 8.7998 1.9714 6.5241 3.24736 4.82688C4.52258 3.13022 6.14331 1.90175 8.10917 1.1409C10.0752 0.380793 12.3801 0 15.0248 0C17.0839 0 18.8626 0.263285 20.3609 0.789854C21.8582 1.31642 23.0164 2.16503 23.836 3.33494C24.6551 4.50559 25.0647 6.05 25.0647 7.96875C25.0647 9.04554 24.9243 10.274 24.6436 11.6547C24.0348 14.4866 23.0987 16.7569 21.8351 18.465C20.5713 20.1737 18.9622 21.4083 17.0082 22.1686C15.054 22.9294 12.7308 23.3095 10.0399 23.3095",
    id: "Fill-6",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M19.7734 10.9173L19.7891 10.9055C19.7832 10.9099 19.7778 10.9138 19.7734 10.9173",
    id: "Fill-9",
    fill: "#63C127",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7358 1.30275L21.8565 7.86085C21.8565 7.86085 20.0436 9.19963 20.0433 9.2C20.345 8.97717 20.5889 8.66881 20.7688 8.34178C20.9137 8.07887 20.7102 7.74907 20.4141 7.74907L16.6921 7.74907L15.8412 11.6715L16.6971 11.6715L2.96542 21.8142L0 24.004C0.0944129 23.9155 3.1245 21.0569 3.49956 19.2835L3.49993 19.283L7.5717 0L25.6227 0C27.6358 0 29.3404 0.434373 30.7358 1.30275",
    id: "Fill-11",
    fill: "#63C127",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0266 21.4745C21.0266 21.5691 21.0102 21.6635 20.9795 21.7581C20.6955 23.1127 19.798 23.7899 18.2861 23.7899L14.0332 23.7899L14.8837 19.868L19.1361 19.868C20.396 19.868 21.0266 20.3249 21.0266 21.2383L21.0266 21.4745ZM32.6268 13.5831C33.367 12.5124 33.8947 11.2206 34.2097 9.7085C34.3355 9.17343 34.3987 8.59069 34.3987 7.96029C34.3987 6.36025 33.9322 5.0006 32.9993 3.88131C32.8059 3.64925 32.79 3.31761 32.9611 3.06873C33.481 2.31251 34.3063 1.49087 34.3252 1.4724L32.1781 3.05783L23.2648 9.64161C23.3476 9.82194 23.389 10.0331 23.389 10.2755C23.389 10.4645 23.3725 10.6225 23.342 10.748C23.0584 12.103 22.1607 12.7802 20.6486 12.7802L19.0155 12.7802L3.19365 24.4663L1.69967 31.5395L13.372 31.5395L31.3921 18.23L32.031 17.7582L33.2112 16.8865C32.8722 17.1368 32.5734 17.2846 32.317 17.3663C32.0325 17.457 31.7213 17.3872 31.5044 17.1821C31.0852 16.7856 30.5852 16.4366 30.0043 16.135C31.012 15.5052 31.8867 14.6547 32.6268 13.5831L32.6268 13.5831Z",
    id: "Fill-13",
    fill: "#63C127",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(13.447951 18.421886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L21.5047 0L21.5047 15.8824L0 15.8824L0 0Z",
    id: "Clip-16",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1338 1.60631C19.9418 1.88697 19.8528 2.22452 19.8794 2.56356C19.8923 2.728 19.8988 2.89835 19.8988 3.07443C19.8988 3.35785 19.8753 3.66492 19.828 3.99583C19.7805 4.32637 19.7253 4.6654 19.6625 5.01183C19.0635 7.87858 17.7489 10.1314 15.7169 11.7691C13.6849 13.407 10.7943 14.2262 7.04605 14.2262L3.99195 14.2262C2.61455 14.2262 0.0785235 15.8326 0 15.8824L2.24208 14.2262L19.6399 1.37592C19.6399 1.37629 19.6403 1.37666 19.6403 1.37702L21.5047 0C21.4859 0.0188456 20.6533 0.84713 20.1338 1.60631",
    id: "Fill-15",
    fill: "#63C127",
    fillRule: "evenodd",
    stroke: "none"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6ad278c6f40d874aeb714d2bd60baf85.svg";
export { ForwardRef as ReactComponent };